import { render, staticRenderFns } from "./UnlinkedCustomersPanel.vue?vue&type=template&id=5d2f5874"
import script from "./UnlinkedCustomersPanel.vue?vue&type=script&lang=js"
export * from "./UnlinkedCustomersPanel.vue?vue&type=script&lang=js"
import style0 from "./UnlinkedCustomersPanel.vue?vue&type=style&index=0&id=5d2f5874&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports